import { render, staticRenderFns } from "./InputFilter.vue?vue&type=template&id=5a23c9e9&"
import script from "./InputFilter.vue?vue&type=script&lang=js&"
export * from "./InputFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports